import { Injectable } from '@angular/core';
import { EncryptWithKeyService } from './flash-payment/flash-payment-core/services/encrypt-with-key.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private cryptoService: EncryptWithKeyService) { }

  sentMessage(title: string, data: any = null) {
    let message = '';
    const payload = {
      type:"user behavior",
      state: title,
      data
    }
    message =  btoa(JSON.stringify(payload)) // this.cryptoService.encryp(JSON.stringify(payload));
    window.parent.postMessage(message, '*');
  }

  sentIframeDimensions(height: string, width: string) {
    let message = '';
    const payload = {
      type:"dimensions",
      state:"dimensions",
      data: {
        height,
        width
      }
    }
    message =  btoa(JSON.stringify(payload)) // this.cryptoService.encryp(JSON.stringify(payload));
    window.parent.postMessage(message, '*');
  }
}
